import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../services/api/apiClient";

const initialState = {
  rows: [],
  status: "idle",
  error: null,
};

export const fetchClientOverview = createAsyncThunk(
  "clientOverview/fetchClientOverview",
  async (_, { rejectWithValue }) => {
    try {
      const data = await apiGet({
        endpoint: "/get-client-overview",
        withAuth: true,
      });
      return data;
    } catch (error: any) {
      return rejectWithValue(
        error.message || "Failed to fetch client overview",
      );
    }
  },
);

const clientOverviewSlice = createSlice({
  name: "clientOverview",
  initialState,
  reducers: {
    clearStatus(state) {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientOverview.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchClientOverview.fulfilled, (state, action: any) => {
        state.status = "succeeded";
        state.rows = action.payload || [];
      })
      .addCase(fetchClientOverview.rejected, (state, action: any) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearStatus } = clientOverviewSlice.actions;
export default clientOverviewSlice.reducer;
